import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';

export default function NotFoundPage() {
  return <section className="section not-found"><Seo title="Page not found" description="The requested CoopCore page could not be found." noIndex/><div className="container"><span>404</span><h1>This page is not part of the platform.</h1><p>Return to the CoopCore website or request a product walkthrough.</p><div><Link className="button button-primary" to="/"><ArrowLeft/> Back to home</Link><Link className="button button-secondary" to="/contact">Contact CoopCore</Link></div></div></section>;
}
